

<div class="col-12" style="height: 300px;text-align: center;padding-top: 50px;color: red;padding-top: 170px;">
<h2>Payment Declined</h2>
</div>